import React from "react";

import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Home from './pages/Home'
import About from './pages/About'
import Contact from './pages/Contact'
import Treatments from './pages/Treatments'
import Treatment from './pages/Treatment'

import { AppStateProvider } from './AppStateContext'; // Replace with the path to your AppStateContext

function App() {

  return (
    <React.StrictMode>
      <AppStateProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/treatments" element={<Treatments />} />
            <Route path='/treatment/:name' element={<Treatment />} />
          </Routes>
        </BrowserRouter>
      </AppStateProvider>
    </React.StrictMode>
  );
}

export default App;
